<template>
  <form class="tariffs-form">
    <div class="tariffs-form__header tariffs-form__section">
      <p class="tariffs-form__title">Выберите способ оплаты</p>
      <div class="tariffs-form__payment-modes">
        <button class="tariffs-form__payment-mode selected" type="button">По счету</button>
        <the-tooltip position="top">
          <template v-slot:trigger="{ listenerObject }">
            <button
              type="button"
              class="tariffs-form__payment-mode disabled"
              v-on="listenerObject"
              v-on:click="onGoalClickOnlineButton"
            >Онлайн</button>
          </template>
          <p>Скоро будет доступно. Следите за обновлениями!</p>
        </the-tooltip>
      </div>
    </div>
    <tariff-row
      v-if="!withoutTariff"
      class="tariffs-form__section"
      select-one
      title="Выберите тариф и продолжительность"
      v-model="selectedTariff"
      v-bind:items="tariffOptions"
    />
    <tariff-row
      v-if="false"
      class="tariffs-form__section"
      title="Выберите дополнительные модули"
      v-model="selectedModules"
      v-bind:items="moduleOptions"
      v-bind:packet-modules="packetModuleOptions"
    />
    <div class="tariffs-form__footer">
      <div class="tariffs-form__total">
        <p class="tariffs-form__title tariffs-form__total__title">Итого:</p>
        <the-rub
          v-if="isShowDiscount"
          class="tariffs-form__price discount"
          v-bind:kop="billingInvoicePrice.original"
          currency="₸"
          showKop="hide" />
        <the-rub
          class="tariffs-form__price"
          v-bind:kop="billingInvoicePrice.final"
          currency="₸"
          showKop="hide" />
      </div>
      <button
        class="tariffs-form__button-submit"
        v-bind:class="{ disabled: isPrintInvoiceButtonDisabled }"
        type="button"
        v-on:click="onClickDownloadInvoice"
      >Скачать счет</button>
    </div>
  </form>
</template>

<script>
import TariffRow from '@/components/TariffRow.vue';
import TheRub from '@/components/TheRub.vue';
import TheTooltip from '@/components/TheTooltip.vue';
import { GOAL_COMPLETED_CLICK_DOWNLOAD_INVOICE, GOAL_COMPLETED_CLICK_ONLINE_BUTTON } from '@/plugins/metric';

/**
 * @description Способ оплаты по счету.
 * @type {string}
 */
const PAYMENT_METHOD_INVOICE = 'invoice';

export default {
  components: {
    TariffRow,
    TheRub,
    TheTooltip,
  },
  computed: {
    billingInvoicePrice() {
      return [...this.selectedTariff, ...this.selectedModules].reduce(
        (result, tariff) => {
          if (tariff.isPacketModule === true) {
            const { cost, count } = tariff;
            return {
              original: result.original + cost * count * 100,
              final: result.final + cost * count * 100,
            };
          }
          const price = tariff.selectedPrice;
          return {
            original: result.original + price.original_price * 100,
            final: result.final + price.final_price * 100,
          };
        },
        { original: 0, final: 0 },
      );
    },
    isShowDiscount() {
      return this.billingInvoicePrice.original !== this.billingInvoicePrice.final;
    },
    isPrintInvoiceButtonDisabled() {
      return this.isAwaitRequest
        || this.selectedTariff.length + this.selectedModules.length === 0;
    },
  },
  data() {
    return {
      /**
       * @description Выбранные модули.
       * @param {any[]}
       */
      selectedModules: [...this.preselectedModules],
      /**
       * @description Выбранные тарифы.
       * @param {any[]}
       */
      selectedTariff: [...this.preselectedTariffs],
    };
  },
  methods: {
    makeRequest() {
      return {
        payment_method: PAYMENT_METHOD_INVOICE,
        tariff_price_ids: this
          .selectedTariff
          .map(({ selectedPrice }) => selectedPrice.id),
        module_price_ids: this
          .selectedModules
          .filter(({ isPacketModule }) => isPacketModule !== true)
          .map(({ selectedPrice }) => selectedPrice.id),
        packet_modules: this
          .selectedModules
          .filter(({ isPacketModule }) => isPacketModule)
          .map((packetModule) => ({
            id: packetModule.selectedTariff.id,
            count: packetModule.count,
          })),
      };
    },
    onClickDownloadInvoice() {
      this.$goal(GOAL_COMPLETED_CLICK_DOWNLOAD_INVOICE);
      if (this.isPrintInvoiceButtonDisabled) {
        return;
      }
      const request = this.makeRequest();
      this.$emit('download', request);
    },
    onGoalClickOnlineButton() {
      this.$goal(GOAL_COMPLETED_CLICK_ONLINE_BUTTON);
    },
  },
  name: 'FormBillingInvoice',
  props: {
    isAwaitRequest: { default: false, type: Boolean },
    moduleOptions: { default: () => [], type: Array },
    packetModuleOptions: { default: () => [], type: Array },
    preselectedModules: { default: () => [], type: Array },
    preselectedTariffs: { default: () => [], type: Array },
    tariffOptions: { default: () => [], type: Array },
    withoutTariff: { default: false, type: Boolean },
  },
};
</script>
